export default {
  getIncentivosFiscais(state) {
    return state.incentivosFiscais;
  },
  getColunas(state) {
    return state.colunasIncentivoFiscal;
  },
  getFiltros(state) {
    return state.filtros;
  },
};
